import { render, staticRenderFns } from "./NotificationsInbox.vue?vue&type=template&id=e74c7d30&scoped=true"
import script from "./NotificationsInbox.vue?vue&type=script&lang=js"
export * from "./NotificationsInbox.vue?vue&type=script&lang=js"
import style0 from "./NotificationsInbox.vue?vue&type=style&index=0&id=e74c7d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74c7d30",
  null
  
)

export default component.exports